import { render, staticRenderFns } from "./PagedOrders.vue?vue&type=template&id=020b1dc6&"
import script from "./PagedOrders.vue?vue&type=script&lang=js&"
export * from "./PagedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports